var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"InfoBanner",class:{
    'is-compact': _vm.compact,
  },attrs:{"role":"note","aria-label":"Information"}},[_c('span',{staticClass:"InfoBanner__icon",attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.iconSvg)}}),_vm._v(" "),_c('p',{staticClass:"InfoBanner__text"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }